/**
 * @package  	Cavalree_Infatree_Theme
 * @copyright	Copyright (c) 2021 Infantree (https://infantree.com/)
 * @version  	1.0.0
 *
 */

if (typeof $ === "undefined") {
    var $ = jQuery;
}

/*****************************
 * Vanilla JS functions
 *****************************/
// addHeadingNonBreakingSpace();
detectScrollbarWidth();
// END Vanilla JS

/*****************************
 * jQuery Ready
 *****************************/
$(document).ready(function () {
    let root = document.documentElement;

    fixedHeaderScroll();
});

function fixedHeaderScroll() {
    let header = $('.site-header');
    let headHeight = header.outerHeight();
    let winScrollPos = $(document).scrollTop();

    if (winScrollPos >= (headHeight / 2)) {
        header.addClass('is-fixed');
    } else {
        header.removeClass('is-fixed');
    }

    $(window).on('scroll', function(e){
        winScrollPos = $(document).scrollTop();

        if (winScrollPos >= (headHeight / 2)) {
            header.addClass('is-fixed');
        } else {
            header.removeClass('is-fixed');
        }        
    });
}

// END jQuery Ready
function detectScrollbarWidth() {
    /* Detect scrollbar width to properly center full- and wide-width elements */
    let root = document.documentElement;
    var outside = document.createElement("div");
    var inside = document.createElement("div");
    
    outside.style.width = inside.style.width = "100%";
    outside.style.overflow = "scroll";
    document.body.appendChild(outside).appendChild(inside);
    
    var scrollbarWidth = outside.offsetWidth - inside.offsetWidth;
    
    outside.parentNode.removeChild(outside);
    root.style.setProperty("--scrollbar-width", scrollbarWidth + "px");
}

function addHeadingNonBreakingSpace() {
    var headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6");

    headings.forEach(function (head, index) {
        let str = head.textContent;
        let firstSection = str.substring(0, str.lastIndexOf(" ") + 1);
        let lastSection = str.substring(str.lastIndexOf(" ") + 1, str.length);

        firstSection = firstSection.trim();

        let newStr = firstSection + "\u00a0" + lastSection;

        head.innerHTML = newStr;
    });
}
